import Groupings from 'Common/Constants/Groupings';

const { Marker, Adhoc, Invigilator, Verifier, AppointmentGroups } = Groupings;

const checklist = {
    [Marker]: [
        'Contract Management',
        'Contract Fees',
        'Contract Spare Fields',
        'Script Allocation',
        'Delivery & Return Dates',
        'Marker Meetings'
    ],
    [Adhoc]: [
        'Contract Management',
        'Contract Fees',
        'Spare Fields',
        'Release Requested',
        'tbc'
    ],
    [Invigilator]: [
        'Contract Management',
        'Contract Fees',
        'Spare Fields'
    ],
    [Verifier]: [
        'Contract Management',
        'Contract Fees',
        'Spare Fields',
        'Release Requested',
        'Verification Level(s)'
    ],
    [AppointmentGroups]: [
        'Contract Management',
        'Contract Fees',
        'Spare Fields',
        'Release Requested'
    ]
};

export default checklist;